// extracted by mini-css-extract-plugin
export default {"pictureBlock":"PictureBlock_pictureBlock__qJWhE","pictureAlt":"PictureBlock_pictureAlt__pN1S5"};